/**
 * Salesforce Service - Handles interactions with Salesforce Edge Function
 * This service calls the Supabase Edge Function which then calls Salesforce APIs
 */

import { supabase } from '../lib/supabase';

/**
 * Creates a lead in Salesforce via the Edge Function
 * @param {Object} leadData - Lead data to create in Salesforce
 * @param {string} supabaseLeadId - ID of the lead in Supabase database
 * @returns {Promise<Object>} Result object with success status and Salesforce lead ID
 */
const createLead = async (leadData, supabaseLeadId) => {
  try {
    // Prepare lead data for Salesforce with proper field mappings
    // CRITICAL FIX: Edge Function expects nested structure with leadData and leadId
    const requestPayload = {
      leadId: supabaseLeadId,
      leadData: {
        customerName: leadData?.customerName,
        email: leadData?.email,
        phone: leadData?.phone,
        propertyAddress: leadData?.propertyAddress,
        propertyCity: leadData?.propertyCity,
        propertyState: leadData?.propertyState,
        propertyZip: leadData?.propertyZip,
        propertyType: leadData?.propertyType,
        homeOwner: leadData?.homeOwner,
        referralType: leadData?.referralType,
        referralNotes: leadData?.referralNotes || '',
        partnerId: leadData?.partnerId,
        referringAccountId: leadData?.referringAccountId,
        referredById: leadData?.referredById
      }
    };

    console.log('🚀 Invoking Salesforce Edge Function with data:', requestPayload);

    // Call the Supabase Edge Function to create lead in Salesforce
    const { data, error } = await supabase?.functions?.invoke('salesforce-lead', {
      body: requestPayload
    });

    if (error) {
      console.error('❌ Edge Function error:', error);
      return {
        success: false,
        error: error?.message || 'Edge function invocation failed',
        details: error
      };
    }

    if (data?.error) {
      console.error('❌ Salesforce API error:', data?.error);
      return {
        success: false,
        error: data?.error,
        skipped: data?.skipped || false
      };
    }

    console.log('✅ Salesforce lead created successfully:', data?.salesforceId);
    return {
      success: true,
      salesforceId: data?.salesforceId,
      message: data?.message
    };

  } catch (error) {
    console.error('❌ Unexpected error in createLead:', error);
    return {
      success: false,
      error: error?.message || 'Unknown error occurred',
      details: error
    };
  }
};

export default {
  createLead
};